// src/utils/dateUtils.js

import moment from "moment";
import "moment/dist/locale/he";
import dayjs from "dayjs";
import "dayjs/locale/he";
import hebrewDate from "hebrew-date";

export function formatMoment(date, format = 'DD/MM/YYYY') {
    if (!date) {
        return '';
    }

    const cleanedDate = date.replace(/\.\d{6}Z$/, 'Z');
    return moment(cleanedDate, moment.ISO_8601).format(format);
}

export function formatJDate(date) {

    if (!date) {
        return '';
    }
    
    const months = [
        "תשרי",
        "חשוון",
        "כסליו",
        "טבת",
        "שבט",
        "אדר א",
        "אדר ב",
        "ניסן",
        "אייר",
        "סיון",
        "תמוז",
        "אב",
        "אלול",
    ];
    const days = [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ז",
        "ח",
        "ט",
        "י",
        "יא",
        "יב",
        "יג",
        "יד",
        "טו",
        "טז",
        "יז",
        "יח",
        "יט",
        "כ",
        "כא",
        "כב",
        "כג",
        "כד",
        "כה",
        "כו",
        "כז",
        "כח",
        "כט",
        "ל",
    ];
    const years = {
        5781: "תשפ״א",
        5783: "תשפ״ג",
        5782: "תשפ״ב",
        5784: "תשפ״ד",
        5785: "תשפ״ה",
        5786: "תשפ״ו",
        5787: "תשפ״ז",
        5788: "תשפ״ח",
    };
    const y = Number(dayjs(date, "YYYY-MM-DD").format("YYYY"));
    const m = dayjs(date, "YYYY-MM-DD").format("M") - 1;
    const d = Number(dayjs(date, "YYYY-MM-DD").format("D"));

    return (
        days[hebrewDate(new Date(y, m, d)).date - 1] +
        " " +
        months[hebrewDate(new Date(y, m, d)).month - 1]
    );
}
